export default __webpack_public_path__ + "static/digital_print-8f1b95bc1967c6060daecd134aab7da8.jpg";